import { getFetchUrl } from './get-fetch-url';
/**
 * @internal
 */
export var getFetchSubEntitiesUrl = function (entityId, subEntityType, productType, includeType) {
    return getFetchUrl(entityId, productType, includeType, subEntityType);
};
